import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useFeatureAccessInsights } from '../featureAccessInsights';

export const useIsMyInsightsEntryPointVisible = (): boolean => {
  const isInsightsLeadersMyAnalyticsPageEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaInsightsLeadersMyAnalytics) === true;
  const isVivaEngagePremium = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;
  const featureAccessInsights = useFeatureAccessInsights();

  return (
    (isInsightsLeadersMyAnalyticsPageEnabled || isVivaEngagePremium) && featureAccessInsights?.canViewActivity === true
  );
};
